/* global  */ // tUrl等のグローバル変数を宣言する

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

/*
  ######  ##      ## #### ########  ######## ########
 ##    ## ##  ##  ##  ##  ##     ## ##       ##     ##
 ##       ##  ##  ##  ##  ##     ## ##       ##     ##
  ######  ##  ##  ##  ##  ########  ######   ########
       ## ##  ##  ##  ##  ##        ##       ##   ##
 ##    ## ##  ##  ##  ##  ##        ##       ##    ##
  ######   ###  ###  #### ##        ######## ##     ##
*/
if (document.getElementsByClassName('js-swiper-mv-left')[0]) {
  // MV左側
  const mvSwiperL = new Swiper('.js-swiper-mv-left', {
    speed: 3000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    loop: true,
    autoplay: {
      delay: 3000,
    },
  })
  // MV右側　左側の連動で動かす
  const mvSwiperR = new Swiper('.js-swiper-mv-right', {
    speed: 3000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    loop: true,
  })

  const slideText = document.getElementsByClassName('js-slideText')
  mvSwiperL.on('slideChangeTransitionStart', function () {
    // スライド時のトリガー
    // 右側のスライドを時間差で動かす
    setTimeout(() => {
      mvSwiperR.slideNext()
    }, 1500)

    // スライドに応じて表示テキストを切り替える
    const slideNo = mvSwiperL.realIndex + 1
    for (let index = 0; index < slideText.length; index++) {
      const element = slideText[index]
      element.classList.remove('active')
      // 指定のクラスを持つ

      if (element.classList.contains('js-slideText--' + slideNo)) {
        element.classList.add('active')
      }
    }
  })
}

let topInterviewSwiper
if (document.getElementsByClassName('js-slide-top-interview')[0]) {
  // SP時だけスライダーにする
  let topInterviewSwiperActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    topInterviewSwiperInit()
    topInterviewSwiperActive = true
  }
  window.addEventListener('resize', function (e) {
    if (topInterviewSwiperActive && window.matchMedia('(min-width:769px)').matches) {
      topInterviewSwiper.destroy()
      topInterviewSwiperActive = false
    } else if (!topInterviewSwiperActive && window.matchMedia('(max-width:768px)').matches) {
      topInterviewSwiperInit()
      topInterviewSwiperActive = true
    }
  })
}

function topInterviewSwiperInit() {
  topInterviewSwiper = new Swiper('.js-slide-top-interview', {
    speed: 700,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      // フェードオプション
      crossFade: true, // クロスフェード
    },
    pagination: {
      el: '.interview__slide__pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.interview__slide__btn__next',
      prevEl: '.interview__slide__btn__prev',
    },
  })
}

if ($('.js-slide-top-project')[0]) {
  // eslint-disable-next-line no-unused-vars
  const topProjectSwiper = new Swiper('.js-slide-top-project', {
    speed: 3000,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 6,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: '.project__slide__pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.project__slide__btn__next',
      prevEl: '.project__slide__btn__prev',
    },
    breakpoints: {
      768: {
        spaceBetween: 60,
        centeredSlides: true,
        slidesPerView: 2.5,
      },
    },
  })
}

// ヘッダー位置監視
if (document.getElementsByClassName('js-contents')[0]) {
  checkHeaderPos()
}
function checkHeaderPos() {
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0.4, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-contents')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        document.getElementById('header').classList.remove('active')
      } else {
        document.getElementById('header').classList.add('active')
      }
    }
  }
}

// 画面に入った監視対象に.animatedを付加
// Intersection Observer
if (document.getElementsByClassName('js-in')[0]) {
  intObs()
}
function intObs() {
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-20px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}
